import React from 'react';
import { useTranslation } from 'react-i18next';
import BasicTabBar, { tabInfo } from 'components/layout/tabs/BasicTabBar';
import translations from 'services/translations/translations';
import tabTypes from './tabTypes';
import { isWoodyTypeDoor } from '../../../types/doorTypes';
import { isWoodyTypeWallByType } from '../../../types/glazingWallTypesCheck';
import IGlassWallDoor from '../../../../interfaces/IGlassWallDoor';

const TabBar = ({
  children,
  selectedTab,
  setSelectedTab,
  glazingWallType,
  doors,
}: {
  children: JSX.Element | null;
  selectedTab: string;
  setSelectedTab: (tab: string) => void;
  glazingWallType: string;
  doors: IGlassWallDoor[];
}): JSX.Element => {
  const { t } = useTranslation([translations.common]);

  const hasWoodyDoor = () => {
    return doors.filter((d) => isWoodyTypeDoor(d)).length > 0;
  };

  const getTabs = () => {
    const tabs: tabInfo[] = [
      {
        tabIcon: '',
        tabLabel: t('Wall properties'),
        tabId: tabTypes.wall,
      },
      {
        tabIcon: '',
        tabLabel: t('Door properties'),
        tabId: tabTypes.door,
      },
      {
        tabIcon: '',
        tabLabel: t('Glass properties'),
        tabId: tabTypes.glass,
      },
    ];

    if (isWoodyTypeWallByType(glazingWallType) || hasWoodyDoor()) {
      tabs.splice(2, 0, {
        tabIcon: '',
        tabLabel: t('Woody wall'),
        tabId: tabTypes.woody,
      });
    }
    return tabs;
  };

  return (
    <>
      <BasicTabBar
        tabs={getTabs()}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
      />
      <div className="tab-content">{children}</div>
    </>
  );
};

export default TabBar;
